// #179 — Poly/Kalshi discrepancy flag for Value Dashboard rows, position-
// independent. Citadel's pinned Dash ask (#8): flag the gap even with no open
// position. Pure adapter over the existing computeDivergence contract
// (lib/divergence/polyKalshiDivergence) — the 2¢ threshold, freshness gate,
// and formatting all live THERE; this file only feeds it a row's paired books.
// The age lookup is injected so the rule is unit-testable (same pattern as
// divergenceRingTickers).
import {
  computeDivergence,
  type DivergenceInfo,
} from '@/lib/divergence/polyKalshiDivergence';
import type { VenueBook } from './types';

export function rowDivergence(
  kBook: VenueBook | undefined | null,
  pBook: VenueBook | undefined | null,
  getOrderbookAgeMs: (ticker: string) => number | null,
): DivergenceInfo | null {
  if (!kBook || !pBook) return null; // unpaired row: nothing to compare
  return computeDivergence(
    kBook,
    pBook,
    pBook.marketTicker,
    getOrderbookAgeMs(pBook.marketTicker),
  );
}
